import React, { createContext, useContext, useState, useCallback } from 'react';

const MobileHeaderContext = createContext(null);

export const MobileHeaderProvider = ({ children }) => {
  const [actions, setActions] = useState(null);
  const [subtitleExtra, setSubtitleExtra] = useState(null);

  const setMobileActions = useCallback((actionsNode) => {
    setActions(actionsNode);
  }, []);

  const clearMobileActions = useCallback(() => {
    setActions(null);
  }, []);

  const setMobileSubtitleExtra = useCallback((text) => {
    setSubtitleExtra(text);
  }, []);

  const clearMobileSubtitleExtra = useCallback(() => {
    setSubtitleExtra(null);
  }, []);

  return (
    <MobileHeaderContext.Provider value={{ actions, setMobileActions, clearMobileActions, subtitleExtra, setMobileSubtitleExtra, clearMobileSubtitleExtra }}>
      {children}
    </MobileHeaderContext.Provider>
  );
};

export const useMobileHeader = () => {
  const ctx = useContext(MobileHeaderContext);
  if (!ctx) return { actions: null, setMobileActions: () => {}, clearMobileActions: () => {} };
  return ctx;
};
